import * as defaultTheme from 'root/theme/default';

const UPDATE_WINDOW_SIZE = 'UPDATE_WINDOW_SIZE';

export default {
  doUpdateWindowSize:
    ({ height, width }) =>
    ({ dispatch, getState, store }) => {
      const state = getState();
      const {
        windowSize: { height: currentHeight, width: currentWidth },
      } = store.selectTheme(state);

      if (height !== currentHeight || width !== currentWidth)
        dispatch({
          payload: {
            height,
            width,
          },
          type: UPDATE_WINDOW_SIZE,
        });
    },
  getReducer:
    () =>
    (state = defaultTheme, { type, payload }) =>
      type === UPDATE_WINDOW_SIZE
        ? (() => {
            const {
              minDesktopWidth,
              maxMobileWidth,
              minTabletWidth,
              maxTabletWidth,
            } = state;
            const { height, width } = payload;
            const widthValue = parseFloat(width.replace('px', ''));
            const windowSize = {
              height,
              isDesktop: widthValue >= minDesktopWidth,
              isMobile: widthValue <= maxMobileWidth,
              isTablet:
                widthValue <= maxTabletWidth && widthValue >= minTabletWidth,
              width,
            };
            return { ...state, windowSize };
          })()
        : state,
  name: 'theme',
  selectTheme: ({ theme }) => theme,
  selectWindowSize: ({ theme: { windowSize } }) => windowSize,
};
